import React from 'react'
import './NewCollections.css'
import newCollections from '../Assets/Frontend_Assets/new_collections'
import Item from '../Item/Item'

const NewCollections = () => {
    return (
        <section className="new-collections">
            <h1>New Collections</h1>
            <hr />

            <div className="collections">
                {newCollections.map(({ id, name, image, new_price, old_price }) => (
                    <Item
                        key={id}
                        id={id}
                        name={name}
                        image={image}
                        new_price={new_price}
                        old_price={old_price}
                    />
                ))}
            </div>
        </section>
    )
}

export default NewCollections